export const formatPrice = (amount, flag = true) => {
    const formattedPrice = new Intl.NumberFormat('fr-MA', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(amount);
    return flag ? `${formattedPrice} DH` : formattedPrice;
};

export const roundToNearestInteger = (num) => {
    return Math.round(num * 100) / 100;
};

export const preventScroll = (e) => {
    e.preventDefault();
};

export const convertNumberToWords = (num) => {
    const ones = ["", "un", "deux", "trois", "quatre", "cinq", "six", "sept", "huit", "neuf", "dix", "onze", "douze", "treize", "quatorze", "quinze", "seize", "dix-sept", "dix-huit", "dix-neuf"];
    const tens = ["", "", "vingt", "trente", "quarante", "cinquante", "soixante", "soixante-dix", "quatre-vingt", "quatre-vingt-dix"];

    if (num === 0) return "zéro";

    const convertBelowHundred = (n) => {
        if (n < 20) return ones[n];
        const ten = Math.floor(n / 10);
        const one = n % 10;
        if (ten === 7 || ten === 9) {
            return tens[ten] + (one > 0 ? "-" + ones[10 + one] : "");
        }
        return tens[ten] + (one > 0 ? "-" + ones[one] : "");
    };

    const convertBelowThousand = (n) => {
        const hundred = Math.floor(n / 100);
        const rest = n % 100;
        const hundredText = hundred > 1 ? ones[hundred] + " cent" : hundred === 1 ? "cent" : "";
        const restText = convertBelowHundred(rest);
        return hundredText + (rest > 0 ? " " + restText : "");
    };


    let result = "";
    const thousand = Math.floor(num / 1000);
    const rest = num % 1000;

    if (thousand > 0) {
        result += thousand > 1 ? convertBelowThousand(thousand) + " mille" : "mille";
    }

    if (rest > 0) {
        result += (result ? " " : "") + convertBelowThousand(rest);
    }

    return result.trim();
};

export const getPrixAchat = (article, fournisseurId) => {
    if (article.fournisseurs && article.fournisseurs.length > 0) {
        const fournisseurRelation = article.fournisseurs.find(f => f.fournisseurId === fournisseurId);
        if (fournisseurRelation) {
            return fournisseurRelation.prixAchatHT;
        }
    }
    return 0; // Default purchase price
};

export const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString();
};

export const formatSigned = (debit, credit) => {
  const d = Number(debit || 0);
  const c = Number(credit || 0);
  const solde = Math.abs(d - c); // always positive value

  if (d > c) {
    // negative solde
    return `-${formatPrice(solde, false)}`;
  } else if (c > d) {
    // positive solde
    return `+${formatPrice(solde, false)}`;
  } else {
    // zero
    return "0.00";
  }
};